import debounce from 'lodash.debounce'
import { MODAL_FROM_CONTEXTS } from 'store/ui/actions'
import toTitleCase from 'lib/title-caser'
import CountFilter from 'components/forms/CountFilter'

export const ReportCountFilter = ({
  filterValues,
  filterKey,
  toggleFilter,
  toggleModal,
  counts,
  upgradeReport,
  fullReport = true,
  modalContext = MODAL_FROM_CONTEXTS.REPORT_FILTER
}) => {
  const toggleFilterDebounced = debounce(toggleFilter, 300)
  const modalType = upgradeReport ? 'upgrade' : 'login'

  const handleChange = values => {
    if (!fullReport) {
      toggleFilter('showMobile', false)
      toggleModal(modalType, true, modalContext)
      return
    }

    toggleFilterDebounced(filterKey, values)
  }

  return (
    <CountFilter
      filterValues={filterValues}
      counts={counts.map(([key, count]) => ({ key, docCount: count }))}
      getLabel={toTitleCase}
      onChange={handleChange}
    />
  )
}

export default ReportCountFilter
